<template>
<div class='vx-col w-full'>
    <div class="p-1 inline-block reloj"> Tiempo: <span class="reloj-size-text">{{ minutes < 10 ? '0'+minutes : minutes }}:{{ seconds < 10 ? '0'+seconds : seconds }}</span>
    </div>
    <transition name="slide">
        <div v-if="game_fin" class="ml-2 p-2 code-color-2 inline-block bg-finalizado text-bold">
            {{ game_finalizado }}
        </div>
    </transition>
    <transition name="slide">
        <div v-if="tiempo_fin" class="p-2 code-color-2 inline-block bg-tiempo_finalizado text-bold">
            {{ tiempo_finalizado }}
        </div>
    </transition>
</div>
</template>

<script>
export default {
    props: {
        conReloj: {
            Type: Boolean,
            default: function () {
                return false;
            },
        },
        game_fin: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },
    components: {},
    data() {
        return {
            seconds: 0,
            minutes: 0,
            timer: null,
            game_finalizado: '!Has finalizado el juego. Felicidades!',
            tiempo_finalizado: '¡Su tiempo ha culminado!',
            tiempo_fin: false,
        };
    },
    watch: {
        game_fin() {
            if (this.game_fin) {
                // console.log('game fin', this.game_fin )
                clearInterval(this.timer);
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            // console.log(this.conReloj)
            if (me.conReloj) me.startTimer();
        },
        startTimer() {
            this.timer = setInterval(() => {
                this.seconds++;
                // console.log('seconds',this.seconds<10)
                // this.seconds < 10 ? '0' + this.seconds : this.seconds
                // this.minutes < 10 ? '0' + this.minutes : this.minutes
                if (this.seconds === 60) {
                    this.seconds = 0;
                    this.minutes++;
                }
                //si llega a 1 hora se detiene el reloj
                if (this.minutes === 59 && this.seconds === 59) {
                    this.tiempo_fin = true;
                    clearInterval(this.timer);
                }
            }, 1000);
        },
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Tilt+Warp&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Jersey+15&family=Play:wght@400;700&display=swap');

.reloj {
    font-family: "Tilt Warp", sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    width: 150px;
    text-align: center;
    padding: 1px;
    // border: 4px solid rgb(56, 55, 56);
    border-radius: 20px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    background-color: #dfdcdc;
}

.reloj-size-text {
    font-size: 1.3em;
    font-family: "Play", sans-serif;
    font-weight: 400;
    font-style: normal;
    padding: 1px;
}

.alto-1 {
    height: 35px;
}

.m-izquierdo {
    margin-left: 20px;
}

.code-color-1 {
    background-color: #dfdcdc;
    color: black;
}

.code-color-2 {
    background-color: #686666;
    color: white;
}

.slide-leave-active,
.slide-enter-active {
    transition: 1s;
}

.slide-enter {
    transform: translate(-100%, 0);
}

.slide-leave-to {
    transform: translate(100%, 0);
}
</style>
